import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import '../../css/sidebar/sidebar.css';

import ecom_color_logo from '../../img/ecom_logo_color.png';

const SettingsSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Hook to get the current URL path

  // Function to check if a link is active
  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Sidebar Toggle Button */}
      <button
        className='fixed close-menu-button top-1 left-1 z-50 p-1 lg:hidden'
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? 'Close' : 'Menu'}
      </button>

      {/* Sidebar */}
      <div
        className={`sidebar fixed top-0 left-0 h-full w-64 transform ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform lg:translate-x-0 overflow-y-auto`}
      >
        {/* Sidebar Content */}
        <div className='flex flex-col items-center bg-[#FAF8FF]'>
          {/* Logo */}
          <div className='mb-12 flex justify-start w-full'>
            <Link to='/overview'>
              <img
                src={ecom_color_logo} // Replace with your logo path
                alt='Logo'
                className='sidebar-logo mt-2 ml-3'
              />
            </Link>
          </div>

          {/* E-Commerce Section */}
          <div className='w-full px-4'>
            <h3 className='sidebar-headings mb-2'>Settings</h3>
            <hr className='heading-list-divider mb-3' />
            <ul className='space-y-2 sidebar-heading-lists'>
              <li
                className={`${
                  isActive('/your-profile')
                    ? 'active-section pl-3 pt-0.5 pb-0.5'
                    : 'pl-3'
                }`}
              >
                <Link to='/your-profile' className='sidebar-heading-lists '>
                  Your Profile
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Commerce Section */}
          <div className='w-full px-4 mt-7'>
            <h3 className='sidebar-headings mb-2'>Organization</h3>
            <hr className='heading-list-divider mb-3' />
            <ul className='space-y-2 sidebar-heading-lists'>
              <li
                className={`${
                  isActive('/key')
                    ? 'active-section pl-3 pt-0.5 pb-0.5'
                    : 'pl-3'
                }`}
              >
                <Link to='/key' className='sidebar-heading-lists'>
                  API Key
                </Link>
              </li>
              <li
                className={`${
                  isActive('/pricing')
                    ? 'active-section pl-3 pt-0.5 pb-0.5'
                    : 'pl-3'
                }`}
              >
                <Link to='/pricing' className='sidebar-heading-lists'>
                  Pricing Plan
                </Link>
              </li>
              <li
                className={`${
                  isActive('/usage')
                    ? 'active-section pl-3 pt-0.5 pb-0.5'
                    : 'pl-3'
                }`}
              >
                <Link to='/usage' className='sidebar-heading-lists'>
                  API Usage
                </Link>
              </li>
              {/* <li
                className={`${
                  isActive('/token-guide')
                    ? 'active-section pl-3 pt-0.5 pb-0.5'
                    : 'pl-3'
                }`}
              >
                <Link
                  to='/subscription-details'
                  className='sidebar-heading-lists'
                >
                  Subscription Details
                </Link>
              </li> */}
              <li
                className={`${
                  isActive('/plan-billing')
                    ? 'active-section pl-3 pt-0.5 pb-0.5'
                    : 'pl-3'
                }`}
              >
                <Link to='/plan-billing' className='sidebar-heading-lists'>
                  Plan and Billing
                </Link>
              </li>

              <li
                className={`${
                  isActive('/transaction-history')
                    ? 'active-section pl-3 pt-0.5 pb-0.5'
                    : 'pl-3'
                }`}
              >
                <Link
                  to='/transaction-history'
                  className='sidebar-heading-lists'
                >
                  Transaction History
                </Link>
              </li>
              <li
                className={`${
                  isActive('/token-guide')
                    ? 'active-section pl-3 pt-0.5 pb-0.5'
                    : 'pl-3'
                }`}
              >
                <Link to='/token-guide' className='sidebar-heading-lists'>
                  API token guide
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div className='w-full px-4 mt-7 mb-6 '>
            <Link to='/help' className='sidebar-headings'>
              <p
                className={`${
                  isActive('/help') ? 'active-section pt-1 pb-1 pl-2' : ''
                }`}
              >
                Help
              </p>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsSidebar;
